import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import wrapReact from '../../util/react';
import { wrapFunc } from '../../util/js';
import { FETCH_CONTINIOUS_INTERVAL } from '../../config';
import {
  actCreateDevice,
  actDeleteDevice,
  actGetDevices,
  actUpdateDevice,
} from '../../redux/action/device';
import { actCiamLogin } from '../../redux/action';
import { actDownloadAccount } from '../../redux/action/account';

export default function CompWrapper(Comp, name) {
  class wrapComp extends Component {
    getDevice = wrapFunc((value, cb, intervalID) => {
      const { auth, intl, dispatch } = this.props;
      clearInterval(intervalID);
      actGetDevices(
        dispatch,
        {
          token: auth.token,
          lang: intl.locale,
          email: auth.email,
        },
        cb,
      );
      return setInterval(
        actGetDevices.bind(
          this,
          dispatch,
          {
            token: auth.token,
            email: auth.email,
          },
          cb,
        ),
        FETCH_CONTINIOUS_INTERVAL,
      );
    }, 'getDevice');

    createDevice = wrapFunc((value, cb) => {
      const { auth, intl, dispatch } = this.props;
      actCreateDevice(
        dispatch,
        {
          token: auth.token,
          lang: intl.locale,
          SerialNumber: value.SerialNumber,
          DisplayName: value.DisplayName,
        },
        cb,
      );
    }, 'createDevice');

    editDevice = wrapFunc((value, cb) => {
      const { auth, intl, dispatch } = this.props;
      actUpdateDevice(
        dispatch,
        {
          token: auth.token,
          lang: intl.locale,
          SerialNumber: value.SerialNumber,
          DisplayName: value.DisplayName,
        },
        cb,
      );
    }, 'editDevice');

    deleteDevice = wrapFunc((value, cb) => {
      const { auth, intl, dispatch } = this.props;
      actDeleteDevice(
        dispatch,
        {
          token: auth.token,
          lang: intl.locale,
          SerialNumber: value.SerialNumber,
        },
        cb,
      );
    }, 'deleteDevice');

    downloadAccount = wrapFunc((value, cb) => {
      const { auth, intl, dispatch } = this.props;
      actDownloadAccount(dispatch, {
        token: auth.token,
        lang: intl.locale,
        SerialNumber: value.SerialNumber,
      }, cb);
    }, 'downloadAccount');

    getCiamToken = wrapFunc((value, cb) => {
      console.log('device/func.jsx--handleAuth');
      console.log('value=', value);
      const { dispatch } = this.props;
      actCiamLogin(dispatch, {
        ciam_code: value,
      }, cb);
    }, 'getCiamToken');

    render() {
      const { devices, ui, dispatch } = this.props;
      return (
        <Comp
          {...this.props}
          ui={ui}
          devices={devices}
          getDevice={this.getDevice}
          createDevice={this.createDevice}
          deleteDevice={this.deleteDevice}
          editDevice={this.editDevice}
          onDownloadAccount={this.downloadAccount}
          getCiamToken={this.getCiamToken}
          dispatch={dispatch}
        />
      );
    }
  }
  wrapComp.propTypes = {
    ui: PropTypes.object.isRequired,
    intl: PropTypes.shape({
      locale: PropTypes.string.isRequired,
    }).isRequired,
    auth: PropTypes.shape({
      token: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }).isRequired,
    devices: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
  };
  function mapStateToProps(state) {
    return {
      auth: state.get('auth'),
      devices: state.get('device'),
      ui: state.get('ui').uiDevice,
    };
  }
  return connect(mapStateToProps)(wrapReact(wrapComp, name));
}
